var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketChat" } }, [
    _c(
      "div",
      { staticClass: "flex-container" },
      [
        _c("div", { staticClass: "header" }, [
          _c(
            "div",
            { staticClass: "vo-icon-button" },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", fab: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.routeRemoveQuery("chat")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { medium: "" } }, [_vm._v("mdi-close")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v("\n      Ticket Chat\n    ")
        ]),
        _vm._v(" "),
        _vm.ticket
          ? [
              _c(
                "div",
                { ref: "chat", staticClass: "chat" },
                [
                  _vm.page.ticketChat.list
                    ? _c("vo-list", {
                        ref: "chatList",
                        attrs: {
                          list: _vm.page.ticketChat.list,
                          forceBottom: "",
                          fill: "",
                          flip: "",
                          lazy: "",
                          endState: false
                        },
                        on: {
                          updated: function($event) {
                            _vm.$forceUpdate()
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "itemSlot",
                            fn: function(item) {
                              return _c("div", {}, [
                                _vm.$store.getters.ticketChat(item.item)
                                  .systemGenerated
                                  ? _c("div", { staticClass: "system" }, [
                                      _c("div", { staticClass: "body" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$store.getters.ticketChat(
                                              item.item
                                            ).body
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "date" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTimeShorthand")(
                                              _vm.$store.getters.ticketChat(
                                                item.item
                                              ).created
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.$store.getters.ticketChat(item.item)
                                        .user
                                        ? _c("div", { staticClass: "name" }, [
                                            _vm._v(
                                              "by " +
                                                _vm._s(
                                                  _vm.$store.getters.user(
                                                    _vm.$store.getters.ticketChat(
                                                      item.item
                                                    ).user
                                                  ).fullName
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "message",
                                        class: {
                                          me:
                                            _vm.$store.getters.ticketChat(
                                              item.item
                                            ).user ===
                                            _vm.$store.getters.profile._id
                                        }
                                      },
                                      [
                                        _c("vo-avatar", {
                                          staticClass: "avatar",
                                          attrs: {
                                            user: _vm.$store.getters.user(
                                              _vm.$store.getters.ticketChat(
                                                item.item
                                              ).user
                                            ),
                                            size: 30
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "message-content" },
                                          [
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$store.getters.user(
                                                    _vm.$store.getters.ticketChat(
                                                      item.item
                                                    ).user
                                                  ).fullName
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "date" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateTimeShorthand")(
                                                    _vm.$store.getters.ticketChat(
                                                      item.item
                                                    ).created
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "body" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$store.getters.ticketChat(
                                                    item.item
                                                  ).body
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                              ])
                            }
                          }
                        ])
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chatbox" },
                [
                  _c(
                    "div",
                    { staticClass: "inputbox" },
                    [
                      _c("v-text-field", {
                        ref: "inputChat",
                        staticClass: "text-field",
                        attrs: {
                          disabled: _vm.lockout,
                          loading: _vm.lockout,
                          "auto-grow": "",
                          "no-resize": "",
                          rows: 1,
                          "multi-line": "",
                          "hide-details": "",
                          placeholder: "Type something..."
                        },
                        on: {
                          keypress: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.send($event)
                          }
                        },
                        model: {
                          value: _vm.chatMessage,
                          callback: function($$v) {
                            _vm.chatMessage = $$v
                          },
                          expression: "chatMessage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "send",
                      attrs: {
                        flat: "",
                        primary: "",
                        small: "",
                        disabled: _vm.lockout
                      },
                      on: { click: _vm.send }
                    },
                    [_vm._v("SEND")]
                  )
                ],
                1
              )
            ]
          : [_c("vo-empty-state", { attrs: { text: "Select a Ticket" } })]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003544b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003544b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketChat.vue
// module id = 593
// module chunks = 4